/*
submitExcellentResponse.js
提交出色的回复
 */

import {message} from "antd";

import submitExcellent from "../../../NetComponents/feedback/submitExcellent";

const submitExcellentResponse = (messages) => {
    try {
        let query = '';
        let response = '';
        let history_query = '';
        let history_response = '';
        if (messages.length >= 3) {
            let lastTwoItems = messages.slice(-2);
            query = lastTwoItems[0].message;
            response = lastTwoItems[1].message;
        }
        if (messages.length >= 5) {
            let lastFourItems = messages.slice(-4);
            history_query = lastFourItems[0].message;
            history_response = lastFourItems[1].message;
        }
        submitExcellent(
            {
                query: query,
                answer: response,
                history_query: history_query,
                history_response: history_response,
                user: 'point5',
            }).then();
    } catch (error) {
        console.log(error);
        message.error('提交失败,请稍后再试').then();
    }
};

export default submitExcellentResponse;